export default async function atualizarCache() {
    const url = `${process.env.REACT_APP_OPENAI_SERVER_EXPRESS}/chamados/atualizar-cache`;
    console.log("Solicitando atualização do cache...");

    try {
        // Recuperar dados do sessionStorage com tratamento de erro
        const getUserSession = () => {
            try {
                const data = sessionStorage.getItem("user");
                return data ? JSON.parse(data) : null;
            } catch (e) {
                console.error("Erro ao processar dados do usuário:", e);
                return null;
            }
        };

        const getCondominioInfo = () => {
            try {
                // Tentar recuperar diretamente o condominioInfo
                const condominioInfoStr = sessionStorage.getItem("condominioInfo");
                if (condominioInfoStr) {
                    console.log("Conteúdo bruto do condominioInfo:", condominioInfoStr);
                    const parsed = JSON.parse(condominioInfoStr);
                    // Se tem id diretamente no condominioInfo
                    if (parsed?.id) {
                        console.log("ID encontrado diretamente em condominioInfo:", parsed.id);
                        return { condominio: { id: parsed.id } };
                    }
                }
                
                // Tentar várias chaves possíveis como fallback
                const keys = ["condominioInfo", "condominio", "condominioData"];
                
                for (const key of keys) {
                    const data = sessionStorage.getItem(key);
                    if (data) {
                        const parsed = JSON.parse(data);
                        // Verificar diferentes estruturas possíveis
                        if (parsed?.condominio?.id) return parsed;
                        if (parsed?.id) return { condominio: { id: parsed.id } };
                        if (typeof parsed === 'object') {
                            // Procurar por qualquer propriedade que tenha um id
                            for (const prop in parsed) {
                                if (parsed[prop]?.id) {
                                    return { condominio: { id: parsed[prop].id } };
                                }
                            }
                        }
                    }
                }
                return null;
            } catch (e) {
                console.error("Erro ao processar dados do condomínio:", e);
                return null;
            }
        };

        const userSession = getUserSession();
        const condominioInfo = getCondominioInfo();

        if (!userSession || !userSession.token) {
            throw new Error("Dados de autenticação não encontrados ou inválidos.");
        }

        if (!condominioInfo || !condominioInfo.condominio || !condominioInfo.condominio.id) {
            // Tente obter o ID de condomínio de outro lugar, se aplicável
            // Por exemplo, da URL ou de outro armazenamento
            const urlParams = new URLSearchParams(window.location.search);
            const condominioId = urlParams.get("condominioId");
            
            if (condominioId) {
                console.log("Usando ID do condomínio da URL:", condominioId);
                const { token } = userSession;
                const body = JSON.stringify({ condominioId });
                
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                    body,
                });
                
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(
                        `Erro ao atualizar o cache: ${errorData.message || response.statusText}`
                    );
                }
                
                const responseData = await response.json();
                console.log("Cache atualizado com sucesso:", responseData);
                return responseData;
            }
            
            throw new Error("Dados do condomínio não disponíveis. Tente fazer login novamente.");
        }

        const { token } = userSession;
        const condominioId = condominioInfo.condominio.id;
        console.log("Atualizando cache para condomínio ID:", condominioId);
        
        const body = JSON.stringify({ condominioId });

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
            body,
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(
                `Erro ao atualizar o cache: ${errorData.message || response.statusText}`
            );
        }

        const responseData = await response.json();
        console.log("Cache atualizado com sucesso:", responseData);
        return responseData;
    } catch (error) {
        console.error("Erro ao atualizar o cache:", error.message);
        throw error;
    }
}